import { posthog } from "posthog-js";
posthog.init("phc_sTM29LbYSwiimviOmkVZxYQk8KAXNMN2grDJXPTVwej", {
    ui_host: "https://app.posthog.com",
    api_host: "https://session-stats.fhub.pl",
});
export { posthog };
